<div class="accessibility-bar" role="region" [attr.aria-label]="'accessibility_bar.label' | translate">
  <div class="container d-flex justify-content-end align-items-center">
    <div class="a11y-group">
      <button
        type="button"
        class="a11y-btn"
        (click)="a11y.increaseFontSize()"
        [attr.aria-label]="'accessibility_bar.increase_font' | translate"
        [disabled]="a11y.fontSize() === 130">
        <svg class="a11y-icon" aria-hidden="true"><use href="assets/image/a11y-icons.svg#text-plus"></use></svg>
        <span class="visually-hidden">A+</span>
      </button>
      <button
        type="button"
        class="a11y-btn"
        (click)="a11y.decreaseFontSize()"
        [attr.aria-label]="'accessibility_bar.decrease_font' | translate"
        [disabled]="a11y.fontSize() === 100">
        <svg class="a11y-icon" aria-hidden="true"><use href="assets/image/a11y-icons.svg#text-minus"></use></svg>
        <span class="visually-hidden">A-</span>
      </button>
    </div>
    <div class="a11y-group">
      <button
        type="button"
        class="a11y-btn"
        (click)="a11y.toggleHighContrast()"
        [attr.aria-label]="'accessibility_bar.toggle_contrast' | translate"
        [attr.aria-pressed]="a11y.highContrast()">
        <svg class="a11y-icon a11y-icon-contrast" aria-hidden="true"><use href="assets/image/a11y-icons.svg#a11y-contrast"></use></svg>
        <span class="a11y-text">{{ 'accessibility_bar.contrast' | translate }}</span>
      </button>
    </div>
    <div class="a11y-group a11y-flags">
      <button
        class="a11y-btn a11y-flag-btn"
        [class.selected]="selectedLanguage() === 'pt'"
        (click)="setLanguage('pt')"
        aria-label="Mudar idioma para Português"
        title="Mudar idioma para Português">
        <img
          ngSrc="assets/image/bandeira-brasil-sq-sm.png"
          alt="Mudar para Português"
          class="rounded-flag"
          width="24"
          height="24" />
      </button>
      <button
        class="a11y-btn a11y-flag-btn"
        [class.selected]="selectedLanguage() === 'en'"
        (click)="setLanguage('en')"
        aria-label="Change language to English"
        title="Change language to English">
        <img
          ngSrc="assets/image/bandeira-eua-sq-sm.png"
          alt="Change to English"
          class="rounded-flag"
          width="24"
          height="24" />
      </button>
      <button
        class="a11y-btn a11y-flag-btn"
        [class.selected]="selectedLanguage() === 'es'"
        (click)="setLanguage('es')"
        aria-label="Cambiar idioma a Español"
        title="Cambiar idioma a Español">
        <img
          ngSrc="assets/image/bandeira-espanha-sq-sm.png"
          alt="Cambiar a Español"
          class="rounded-flag"
          width="24"
          height="24" />
      </button>
    </div>
  </div>
</div>
<nav class="navbar navbar-expand-lg navbar-dark bg-primary" style="min-height:56px">
  <h2 class="visually-hidden">Menu de navegação</h2>
  <div class="container">
    <a class="navbar-brand" routerLink="/">
      <div class="inline-grid">
        <img ngSrc="assets/image/unicamp-logo.png" width="36" height="40" alt="Unicamp" title="Unicamp" priority />
      </div>
    </a>
    <a class="navbar-brand" routerLink="/">
      <div class="inline-grid">
        <img ngSrc="assets/image/detic-logo.png" width="105" height="28" alt="Detic" title="Detic" priority />
      </div>
    </a>
    <button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target=".navbar-collapse"
      aria-controls="navbar"
      aria-expanded="false"
      aria-label="Abrir menu de navegação">
      <span class="navbar-toggler-icon">&nbsp;</span>
    </button>
    <div class="collapse navbar-collapse" id="navbar">
      <ul class="navbar-nav mr-auto mb-2 mb-md-0">
        <li class="nav-item">
          <a
            class="nav-link"
            data-bs-toggle="collapse"
            data-bs-target=".navbar-collapse.show"
            routerLink="/concurso/inscricao-aberta"
            routerLinkActive="a11y-current" #rla="routerLinkActive"
            [attr.aria-current]="rla.isActive ? 'page' : null"
            >{{ 'shared.concursos' | translate }} v{{ version }}</a
          >
        </li>
      </ul>
      <ul class="navbar-nav ms-auto mb-2 mb-md-0">
        @if (!usuarioService.isLoggedIn()) {
          <li class="nav-item">
            <a
              class="nav-link"
              data-bs-toggle="collapse"
              data-bs-target=".navbar-collapse.show"
              routerLink="/sistema/entrar"
              routerLinkActive="a11y-current" #rlaEntrar="routerLinkActive"
              [attr.aria-current]="rlaEntrar.isActive ? 'page' : null"
              ><i class="bi bi-person" aria-hidden="true"></i> {{ 'shared.area_do_candidato' | translate }}</a
            >
          </li>
        }
        @if (usuarioService.isLoggedIn()) {
          <li class="nav-item dropdown">
            <button
              type="button"
              class="nav-link dropdown-toggle" id="navbarDropdownMenuLink"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              ><i class="bi bi-person-circle" aria-hidden="true"></i> {{ 'shared.area_do_candidato' | translate }}</button>
            <ul class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
              <li>
                <a
                  class="dropdown-item"
                  data-bs-toggle="collapse"
                  data-bs-target=".navbar-collapse.show"
                  routerLink="/candidato/inscricoes"
                  routerLinkActive="a11y-current" #rlaInscricoes="routerLinkActive"
                  [attr.aria-current]="rlaInscricoes.isActive ? 'page' : null"
                  title="{{ 'header.minhas_inscricoes' | translate }}"
                  ><i class="bi bi-journal-text" aria-hidden="true"></i> {{ 'header.inscricoes' | translate }}</a
                >
              </li>
              <li>
                <a
                  class="dropdown-item"
                  data-bs-toggle="collapse"
                  data-bs-target=".navbar-collapse.show"
                  routerLink="/candidato/recursos"
                  routerLinkActive="a11y-current" #rlaRecursos="routerLinkActive"
                  [attr.aria-current]="rlaRecursos.isActive ? 'page' : null"
                  title="{{ 'header.meus_recursos' | translate }}"
                  ><i class="bi bi-exclamation-triangle" aria-hidden="true"></i>
                  {{ 'recurso_shared.recursos' | translate }}</a
                >
              </li>
              <li><hr class="dropdown-divider" /></li>
              <li>
                <a
                  class="dropdown-item"
                  data-bs-toggle="collapse"
                  data-bs-target=".navbar-collapse.show"
                  routerLink="/candidato/email-alterar"
                  routerLinkActive="a11y-current" #rlaEmail="routerLinkActive"
                  [attr.aria-current]="rlaEmail.isActive ? 'page' : null"
                  ><i class="bi bi-envelope" aria-hidden="true"></i> {{ 'header.alterar_email' | translate }}</a
                >
              </li>
              <li>
                <a
                  class="dropdown-item"
                  data-bs-toggle="collapse"
                  data-bs-target=".navbar-collapse.show"
                  routerLink="/candidato/senha-alterar"
                  routerLinkActive="a11y-current" #rlaSenha="routerLinkActive"
                  [attr.aria-current]="rlaSenha.isActive ? 'page' : null"
                  ><i class="bi bi-key" aria-hidden="true"></i> {{ 'header.alterar_senha' | translate }}</a
                >
              </li>
            </ul>
          </li>
        }
        <li class="nav-item">
          <a
            class="nav-link"
            href="https://detic.unicamp.br/documento/manual-sistema-de-inscricao-de-concurso/"
            target="_blank"
            rel="noopener noreferrer"
            ><i class="bi bi-book" aria-hidden="true"></i> {{ 'header.manual' | translate }}</a
          >
        </li>
        @if (usuarioService.isLoggedIn()) {
          <li class="nav-item">
            <button
              type="button"
              class="nav-link"
              data-bs-toggle="collapse"
              data-bs-target=".navbar-collapse.show"
              (click)="usuarioService.logout()">
              <i class="bi bi-box-arrow-right" aria-hidden="true"></i> {{ 'header.sair' | translate }}
            </button>
          </li>
        }
      </ul>
    </div>
  </div>
</nav>
